const STEP_ICON_CLASS = {
  done: "text-dark",
  active: "text-warning",
  pending: "text-secondary"
};

const STEP_BADGE_CLASS = {
  done: "bg-warning",
  active: "bg-warning-subtle border border-warning",
  pending: "bg-light border"
};

export default {
  name: "BolideLoader",
  props: {
    redirect_on_complete: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      steps: [
        {
          key: "access",
          label: "Validating access",
          description: "Checking your secure platform session.",
          icon: "bi-shield-check"
        },
        {
          key: "insights",
          label: "Loading insights",
          description: "Preparing production and performance views.",
          icon: "bi-bar-chart-line"
        },
        {
          key: "enter",
          label: "Entering platform",
          description: "Taking you to your dashboard workspace.",
          icon: "bi-arrow-right"
        }
      ],
      current_step: 0,
      progress: 35,
      all_done: false,
      timers: []
    };
  },
  mounted() {
    this.timers.push(setTimeout(() => {
      this.current_step = 1;
      this.progress = 70;
    }, 650));

    this.timers.push(setTimeout(() => {
      this.current_step = 2;
      this.progress = 100;
    }, 1300));

    this.timers.push(setTimeout(() => {
      this.all_done = true;
    }, 1850));

    this.timers.push(setTimeout(() => {
      if (this.redirect_on_complete) {
        this.$router.replace("/home");
      }
    }, 2250));
  },
  beforeUnmount() {
    this.timers.forEach((timer) => clearTimeout(timer));
    this.timers = [];
  },
  methods: {
    loader_step_status(index) {
      if (this.all_done || index < this.current_step) {
        return "done";
      }

      return index === this.current_step ? "active" : "pending";
    },
    loader_step_row_class(index) {
      return `loader-step-${this.loader_step_status(index)}`;
    },
    loader_step_badge_class(index) {
      return STEP_BADGE_CLASS[this.loader_step_status(index)];
    },
    loader_step_icon_class(step, index) {
      const status = this.loader_step_status(index);
      const icon = status === "done" ? "bi-check-lg" : step.icon;

      return `bi ${icon} ${STEP_ICON_CLASS[status]}`;
    }
  }
};
